import { apiGet, apiPost } from './api';

// The student's own syllabus: what we have mapped for their board + class, the
// chapters they have filed for review, and their verdict on each mapped chapter.

export const fetchMySyllabus = () => apiGet('/syllabus/my');
export const uploadMySyllabus = (payload) => apiPost('/syllabus/my/upload', payload);
export const sendChapterFeedback = (payload) => apiPost('/syllabus/my/chapter-feedback', payload);
export const searchSchools = (q, state = '', city = '') =>
  apiGet(`/schools/search?q=${encodeURIComponent(q)}&state=${encodeURIComponent(state)}&city=${encodeURIComponent(city)}`);
export const suggestSchool = (payload) => apiPost('/schools/suggest', payload);

export const CLASS_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export const BOARD_OPTIONS = [
  'CBSE (Central Board of Secondary Education)',
  'CISCE (ICSE/ISC)',
  'NIOS (National Institute of Open Schooling)',
  'IB (International Baccalaureate)',
  'Cambridge (IGCSE / A Levels)',
  'State Board',
];

// Shown beside the file picker. Caps and bold are deliberate: the owner's point
// is that a naming rule nobody reads is a naming rule nobody follows.
export const SYLLABUS_NAMING_HELP = {
  rule: 'ONE CHAPTER PER UPLOAD',
  pattern: 'BOARD_CLASS_SUBJECT_CHAPTER',
  why: 'Our team searches by this name, so a correctly named file is reviewed in hours instead of days.',
};

export const SYLLABUS_RIGHTS_COPY =
  'You can only upload pages from books you own and have paid for — not files downloaded from somewhere on the internet. ' +
  'A book being available online does not make it free to share, and our review is not permission to redistribute it.';
